module.exports = __webpack_public_path__ + "img/logo-footer.99671a32.webp";